import { Alert, Box, Skeleton } from '@mui/material';
import { useEffect, useState } from 'react';
import CardActions from "src/pages/sistema/components/CardActions";
import { FileBlobResponseFields } from 'src/types/files/filesData';
import { useNOTESGrafico } from '../hooks/useNOTESGrafico';
import { SafetyComponent } from 'src/components/security';
import { WorkflowSecObjects } from 'src/types/security';
import CardAltaGraficoNOTES from './SeccionNOTESAltaGraficoSubyacentes';

interface SeccionNOTESVisualizarArchivoProps {
  idOperacion: number;
  codSistema: number;
  codSistemaPrincipal: number;
  codSistemaTipo: number;
}

const SeccionNOTESVisualizarArchivo = ({ 
  idOperacion, 
  codSistema, 
  codSistemaPrincipal, 
  codSistemaTipo 
}: SeccionNOTESVisualizarArchivoProps) => {
  
  const { data, isLoading, isError, refetch } = useNOTESGrafico(idOperacion);
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  useEffect(() => {
    // Si hay datos y viene el archivo, armamos la URL
    if (data && data[FileBlobResponseFields.File]) {
      const binaryData = data[FileBlobResponseFields.File];
      const blob = new Blob([binaryData]);
      const url = window.URL.createObjectURL(blob);
      setImageUrl(url);

      return () => {
        window.URL.revokeObjectURL(url);
      };
    } else {
      setImageUrl(null);
    }
  }, [data]);

  const handleSuccessUpload = () => {
    // recargar despues de hacer el upload
    if (refetch) refetch();
  };

  return (
    <CardActions title='Gráfico de precios de variación de sub-yacentes' icon='mdi:chart-line' colapsable>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          p: 2,
        }}
      >
        {isLoading ? (
          <Skeleton variant='rectangular' width="100%" height={300} sx={{ borderRadius: 1 }} />
        ) : imageUrl ? (
          // si hay imagen la mostramos
          <img
            src={imageUrl}
            alt="Gráfico de precios de variación de sub-yacentes"
            style={{
              maxWidth: '100%',
              maxHeight: '600px',
              height: 'auto',
              display: 'block',
              borderRadius: '4px',
              boxShadow: '0px 3px 6px rgba(0,0,0,0.1)'
            }}
          />
        ) : (
          // si no hay imagen mostramos el Alert y si tiene permisos el formulario de alta
          <Box sx={{ width: '100%' }}>
            <Alert severity='info' sx={{ width: '100%', mb: 3 }}>
              No se encontró gráfico de subyacentes
            </Alert>

            {/* <SafetyComponent code={WorkflowSecObjects.BotonGraficoSubyacentes}>
              <CardAltaGraficoNOTES 
                idOperacion={idOperacion} 
                codSistema={codSistemaTipo}
                idPais={codSistemaPrincipal}
                onSuccess={handleSuccessUpload} 
              />
            </SafetyComponent> */}
          </Box>
        )}
      </Box>
    </CardActions>
  );
};

export default SeccionNOTESVisualizarArchivo;